import { withStyles } from '@material-ui/core';
import { ImageField } from 'react-admin';

const styles = (theme) => ({
  image: {
    maxWidth: 30,
    maxHeight: 30,
    margin: 0,
    marginRight: '0.5rem',
  },
});

export default withStyles(styles)(ImageField);
